var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimfixAreas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 21.6251V16.6251H4.45V19.5501H7.375V21.6251H2.375ZM16.625 21.6251V19.5501H19.55V16.6251H21.65V21.6251H16.625ZM12 19.5001C9.91667 19.5001 8.14583 18.7709 6.6875 17.3126C5.22917 15.8543 4.5 14.0834 4.5 12.0001C4.5 9.91676 5.22917 8.14593 6.6875 6.6876C8.14583 5.22926 9.91667 4.5001 12 4.5001C14.0833 4.5001 15.8542 5.22926 17.3125 6.6876C18.7708 8.14593 19.5 9.91676 19.5 12.0001C19.5 14.0834 18.7708 15.8543 17.3125 17.3126C15.8542 18.7709 14.0833 19.5001 12 19.5001ZM12 17.1251C13.4333 17.1251 14.65 16.6293 15.65 15.6376C16.65 14.6459 17.15 13.4334 17.15 12.0001C17.15 10.5668 16.6458 9.3501 15.6375 8.3501C14.6292 7.3501 13.4167 6.8501 12 6.8501C10.5667 6.8501 9.35417 7.35426 8.3625 8.3626C7.37083 9.37093 6.875 10.5834 6.875 12.0001C6.875 13.4334 7.37083 14.6459 8.3625 15.6376C9.35417 16.6293 10.5667 17.1251 12 17.1251ZM2.375 7.3751V2.3501H7.375V4.4501H4.45V7.3751H2.375ZM19.55 7.3751V4.4501H16.625V2.3501H21.65V7.3751H19.55Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimfixAreas);
export default __webpack_public_path__ + "static/media/simfix_areas.2ef68f896d3a8774cb64d39661574f88.svg";
export { ForwardRef as ReactComponent };